export const DESKTOP_DRAWER_WIDTH = 450;
export const MOBILE_DRAWER_MAX_HEIGHT = '80vh';
export const MOBILE_POWERED_BY_HEIGHT = 29;
export const MOBILE_TAB_BAR_HEIGHT = 65;
export const MOBILE_TABS_HEIGHT = MOBILE_TAB_BAR_HEIGHT + MOBILE_POWERED_BY_HEIGHT;
